import React from 'react';
import { motion } from 'framer-motion';
const services = [{
  title: 'Braces - Frenos',
  desc: 'Improve your smile and love the way you smile. / Mejora tu sonrisa y ama tu forma de sonreír.',
  img: 'https://cdn.magicpatterns.com/uploads/tbWnDwzMDGimyQqQfWXAZ4/ChatGPT_Image_Jun_23,_2026,_03_17_18_PM.png',
  price: 'Free Consultation'
}, {
  title: 'Veneers - Carillas',
  desc: 'Change your smile with veneers, book your appointment today! / Cambia tu sonrisa con carillas, ¡reserva tu cita hoy!',
  img: 'https://cdn.magicpatterns.com/uploads/2WrtrhKG49ofwBxisGsbxx/pasted-image.jpg',
  price: 'Free Consultation'
}, {
  title: 'Crowns and Bridges - Coronas y Puentes Dentales',
  desc: 'Crowns and bridges can easily replace missing teeth. Get both a new smile and also the ability to eat and chew properly.',
  img: 'https://cdn.magicpatterns.com/uploads/hUFZT6913ZakNRpPwfL21M/Gemini_Generated_Image_9ydslw9ydslw9yds.png',
  price: 'Free Consultation'
}, {
  title: 'Exam Cleaning Xrays',
  desc: 'Dental cleaning x-rays and comprehensive exam.',
  img: 'https://cdn.magicpatterns.com/uploads/atYr4HzQUVyvmeLs4ffva8/ChatGPT_Image_Jun_23,_2026,_03_07_45_PM.png',
  price: 'Free Consultation'
}, {
  title: 'Extraction - Extraccion',
  desc: 'Extraction. / Extraccion.',
  img: 'https://cdn.magicpatterns.com/uploads/efNasSzDNXD9T51LANTFFr/Gemini_Generated_Image_njoi0xnjoi0xnjoi.png',
  price: 'Free Consultation'
}, {
  title: 'Teeth Whitening',
  desc: 'Brighten your smile with our 1 hour whitening. / Ilumina tu sonrisa con nuestro blanqueamiento de 1 hora.',
  img: 'https://cdn.magicpatterns.com/uploads/2WswGMn6MLeSktEQXy5nFh/ChatGPT_Image_Jun_23,_2026,_03_09_22_PM.png',
  price: 'Free Consultation'
}, {
  title: 'Dental Implants - Implante',
  desc: 'Dental Implants replace your missing teeth.',
  img: 'https://cdn.magicpatterns.com/uploads/eFYruGFgromJp8XFhqyton/ChatGPT_Image_Jun_23,_2026,_03_11_52_PM.png',
  price: 'Free Consultation'
}, {
  title: 'Invisalign',
  desc: "Don't want wires in your mouth? No problem, straighten your teeth and perfect your smile with clear aligners.",
  img: 'https://cdn.magicpatterns.com/uploads/m6pW2VBERSLr62bh5W2BXa/Gemini_Generated_Image_j5xp9ej5xp9ej5xp.png',
  price: 'Free Consultation'
}, {
  title: 'Dentures - Dentadura',
  desc: 'Dentures are a perfect economic way to recreate your brilliant smile with teeth that you can use for chewing and eating.',
  img: 'https://cdn.magicpatterns.com/uploads/19UejF4E7FxZpQmwbETozq/ChatGPT_Image_Jun_23,_2026,_03_15_49_PM.png',
  price: 'Free Consultation'
}];
export function Services() {
  return <section id="services" className="py-24 bg-slate-50" data-id="element-280">
      <div className="max-w-7xl mx-auto px-4" data-id="element-281">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-3xl font-bold text-[#225274] mb-12 text-center tracking-tight" data-id="element-282">
          OUR FULL-SERVICE TREATMENT SUITE
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-283">
          {services.map((service, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-white rounded-[12px] overflow-hidden shadow-sm hover:shadow-md transition-shadow group" data-id="element-284">
              <div className="h-48 overflow-hidden" data-id="element-285">
                <img src={service.img} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-286" />
              </div>
              <div className="p-6" data-id="element-287">
                <div className="mb-4" data-id="element-288">
                  <span className="inline-block text-[10px] font-bold text-[#54c595] bg-[#cef4d2]/50 px-2 py-0.5 rounded-full uppercase tracking-widest mb-2" data-id="element-289">
                    {service.price}
                  </span>
                  <h3 className="text-xl font-extrabold text-[#225274] leading-tight" data-id="element-290">
                    {service.title}
                  </h3>
                </div>
                <p className="text-sm text-slate-600 mb-6 leading-relaxed" data-id="element-291">
                  {service.desc}
                </p>
                <a href="/book" className="text-sm font-bold text-[#54c595] hover:text-[#4bafbc] flex items-center gap-1 transition-colors" data-id="element-292">
                  Book Appointment →
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}